import fs from 'fs';

const doesFileExists = filePath => fs.existsSync(filePath);

export default doesFileExists;